<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-car-ext-main-list [listType]="DtgListType.list"></dtg-manage-car-ext-main-list>
    </div>
</div>